import { useMutation, UseMutationResult, useQueryClient } from "react-query";
import { API, CustomAxiosError } from "../../../../../logics/api-config";

export interface CreateBillingDataPayload {
    ris_id?: number;
    company_name: string;
    contact_name: string;
    address: string | null;
    city: string | null;
    zip: string | null;
    province: string | null;
    vat: string | null;
    tax_id: string | null;
    payment_code: string;
    payment_method: string;
    unique_email?: string | null;
}

const useApiCreateBillingData = (
    invalidateKeys?: (string | number)[]
): UseMutationResult<void, CustomAxiosError, CreateBillingDataPayload, unknown> => {
    const queryClient = useQueryClient();

    return useMutation<void, CustomAxiosError, CreateBillingDataPayload>(
        async (payload) => {
            await API.post(`/accounting/billing-data`, payload);
        },
        {
            onSuccess: async () => {
                if (invalidateKeys && invalidateKeys.length > 0) {
                    await queryClient.invalidateQueries(invalidateKeys);
                } else {
                    await Promise.all([
                        queryClient.invalidateQueries(["getAccountingStripeRecap"]),
                        queryClient.invalidateQueries(["getAccountingCashRecap"]),
                        queryClient.invalidateQueries(["getAccountingBookingRecap"]),
                        queryClient.invalidateQueries(["getBillingData"]),
                    ]);
                }
            },
        }
    );
};

export default useApiCreateBillingData;
